<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="member"
          :title="title"
          :url="url"
          :columns="columns"
          :filter="filter"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :on-click-export="onClickExport"
          :action-width="180"
        >
          <template v-slot:action>
            <v-col md="3">
              <v-autocomplete
                label="Fitness Consultant"
                dense
                outlined
                v-model="filterFitnessConsultant"
                :items="listFitnessConsultants"
                item-text="name"
                item-value="id"
                hide-details="true"
                clearable
              />
            </v-col>
            <v-col md="3">
              <v-autocomplete
                label="Personal Trainer"
                dense
                outlined
                v-model="filterPersonalTrainer"
                :items="listPersonalTrainers"
                item-text="name"
                item-value="id"
                hide-details="true"
                clearable
              />
            </v-col>
            <v-col md="3">
              <v-checkbox
                label="Hanya Member Sudah Expired"
                v-model="filterExpiredOnly"
                hide-details="true"
                dense
              />
            </v-col>
            <v-col md="3">
              <date-picker
                placeholder="Tanggal Expired Dari"
                valueType="format"
                :format="'DD/MM/YYYY'"
                v-model="filterExpiredDateStart"
                :disabled="filterExpiredOnly"
              />
            </v-col>
            <v-col md="3">
              <date-picker
                placeholder="Tanggal Expired Sampai"
                valueType="format"
                :format="'DD/MM/YYYY'"
                v-model="filterExpiredDateEnd"
                :disabled="filterExpiredOnly"
              />
            </v-col>
            <v-col md="3">
              <v-btn
                v-if="canAdd"
                depressed
                class="ma-1"
                color="primary"
                small
                @click="importDialog = true"
                :loading="loading"
              >
                <v-icon small left> mdi-plus </v-icon>
                Import
              </v-btn>
            </v-col>
          </template>
          <template v-slot:[`item.username`]="{ item }">
            <div style="width: 100px">
              {{ item.username }}
            </div>
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <div style="width: 100px">
              {{ item.name }}
            </div>
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <div style="width: 100px">
              {{ item.name }}
            </div>
          </template>
          <template v-slot:item.active="{ item }">{{
            item.active ? "Aktif" : "Tidak Aktif"
          }}</template>
          <template v-slot:[`item.whatsapp_reminder`]="{ item }">
            <div style="width: 55px; text-align: center">
              <v-btn
                v-if="item.whatsapp_reminder"
                icon
                small
                :href="`https://wa.me/${formatWhatsapp(
                  item.whatsapp_reminder
                )}`"
                target="_blank"
                color="green darken-2"
              >
                <v-icon>mdi-whatsapp</v-icon>
              </v-btn>
              <v-icon v-else color="grey lighten-1" small>
                mdi-close-circle
              </v-icon>
            </div>
          </template>

          <template v-slot:[`item.join_date`]="{ item }">
            <div v-if="item.join_date != null">
              {{ item.join_date | moment("DD/MM/YYYY") }}
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            <div v-if="item.created_at != null">
              {{ item.created_at | moment("DD/MM/YYYY HH:mm") }}
            </div>
            <div v-else>-</div>
          </template>

          <template v-slot:[`item.last_checkin`]="{ item }">
            <div v-if="item.last_checkin != null">
              {{ item.last_checkin | moment("DD/MM/YYYY") }}
            </div>
            <div v-else>-</div>
          </template>

          <template v-slot:[`item.membership_expired_date`]="{ item }">
            <div v-if="item.membership_expired_date != null">
              {{ item.membership_expired_date | moment("DD/MM/YYYY") }}
            </div>
            <div v-else>-</div>
          </template>
        </datatable>
      </div>
    </div>
    <form-user ref="form" module="member" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="user"
      :success="deleteSuccess"
    ></delete-dialog>
    <v-dialog v-model="importDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>Import User via Excel</v-card-title>
        <v-card-text>
          <v-file-input
            v-model="importFile"
            accept=".xlsx, .xls"
            label="Pilih File Excel"
            dense
            outlined
            prepend-icon="mdi-file-excel"
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="importDialog = false">Batal</v-btn>
          <v-btn color="primary" :loading="importing" @click="submitImport"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormUser from "./FormUser";
import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import Moment from "moment";

export default {
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Manajemen Member", route: "" },
      { title: "Member" },
    ]);

    const { data } = await ApiService.get("role/list");
    this.listRole = data;

    // Ambil role ID 'member' dari API
    const { data: roleList } = await ApiService.get("role/list");
    this.listRole = roleList;
    const memberRole = roleList.find((r) => r.name.toLowerCase() === "member");

    const { data: fcList } = await ApiService.get(
      "user/list?role_slug=fitness-consultant"
    );
    this.listFitnessConsultants = fcList;

    const { data: ptList } = await ApiService.get(
      "user/list?role_slug=personal-trainer"
    );
    this.listPersonalTrainers = ptList;

    if (memberRole) {
      this.memberRoleId = memberRole.id;
      this.setDefaultFilter();
    }
  },
  data() {
    return {
      importDialog: false,
      importFile: null,
      importing: false,
      title: "Member",
      url: "user/data",
      columns: [
        {
          value: "id",
        },
        {
          text: "Username",
          value: "username",
          sortable: true,
          searchable: true,
        },
        {
          text: "Nama Lengkap",
          value: "name",
          sortable: true,
          searchable: true,
        },
        {
          text: "Email",
          value: "email",
          sortable: true,
          searchable: true,
        },
        {
          text: "Role",
          value: "role_name",
          sortable: true,
          searchable: true,
        },
        {
          text: "Status",
          value: "active",
          sortable: true,
          searchable: false,
        },
        {
          text: "Whatsapp Reminder",
          value: "whatsapp_reminder",
          sortable: true,
          searchable: false,
        },
        {
          text: "Last Checkin",
          value: "last_checkin",
          sortable: true,
          searchable: false,
        },
        {
          text: "Membership Expired",
          value: "membership_expired_date",
          sortable: true,
          searchable: false,
        },
        {
          text: "Tanggal Dibuat",
          value: "created_at",
          sortable: true,
          searchable: false,
        },
      ],
      listRole: [],
      listFitnessConsultants: [],
      listPersonalTrainers: [],
      filterRole: null,
      filterFitnessConsultant: null,
      filterPersonalTrainer: null,
      filterExpiredOnly: false,
      filterExpiredDateStart: null,
      filterExpiredDateEnd: null,
      filter: null,
      memberRoleId: null,
      excludedRoleId: null,
    };
  },
  methods: {
    async submitImport() {
      if (!this.importFile) {
        this.$swal.fire({
          icon: "error",
          title: "Gagal",
          text: "Silakan pilih file Excel untuk diimpor",
        });
        return;
      }

      this.importing = true;

      const formData = new FormData();
      formData.append("file", this.importFile);

      try {
        const response = await ApiService.post("member/import", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        // ✅ Tangani respons sukses
        if (response.data && response.data.success) {
          this.$swal.fire({
            icon: "success",
            title: "Sukses",
            text: response.data.message || "Data berhasil diimpor",
          });
          this.importDialog = false;
          this.importFile = null;
          this.formSuccess?.(); // kalau ada callback setelah sukses
        } else {
          // ✅ Kasus: backend balikin success: false tapi status 200
          this.swal.fire({
            icon: "error",
            title: "Gagal",
            text: response.data.message || "Gagal import data",
          });
        }
      } catch (error) {
        let errorMessage = "Gagal import data";

        if (error.response?.data) {
          const { message, error: errorField } = error.response.data;
          errorMessage = message || errorField || error.response.statusText;
        } else if (error.message) {
          errorMessage = error.message;
        }

        this.$swal.fire({
          icon: "error",
          title: "Gagal",
          text: errorMessage,
        });
      } finally {
        this.importing = false;
      }
    },
    setDefaultFilter() {
      const finalFilter = [];

      if (this.memberRoleId) {
        finalFilter.push({
          column: "active_role",
          value: this.memberRoleId,
          operator: "eq",
        });
      }

      if (this.filterFitnessConsultant) {
        finalFilter.push({
          column: "fitness_consultant_id",
          value: this.filterFitnessConsultant,
          operator: "eq",
        });
      }

      if (this.filterPersonalTrainer) {
        finalFilter.push({
          column: "personal_trainer_id",
          value: this.filterPersonalTrainer,
          operator: "eq",
        });
      }

      // Filter: member yang sudah expired (membership_expired_date <= hari ini)
      if (this.filterExpiredOnly) {
        finalFilter.push({
          column: "membership_expired_date",
          operator: "lte",
          value: Moment().format("YYYY-MM-DD"),
        });
      } else {
        if (this.filterExpiredDateStart) {
          finalFilter.push({
            column: "membership_expired_date",
            operator: "gte",
            value: Moment(this.filterExpiredDateStart, "DD/MM/YYYY").format("YYYY-MM-DD"),
          });
        }
        if (this.filterExpiredDateEnd) {
          finalFilter.push({
            column: "membership_expired_date",
            operator: "lte",
            value: Moment(this.filterExpiredDateEnd, "DD/MM/YYYY").format("YYYY-MM-DD"),
          });
        }
      }

      this.filter = finalFilter.length > 0 ? finalFilter : null;
    },
    formatWhatsapp(phone) {
      // Hapus spasi, tanda plus, strip, dll → sesuaikan ke format wa.me (62...)
      return phone
        .replace(/\D/g, "") // ambil angka aja
        .replace(/^0/, "62"); // ganti 0 jadi 62
    },
    onClickCreate() {
      this.$refs.form.open();
    },
    onClickUpdate(item) {
      this.$refs.form.open(item.id);
    },
    onClickDelete(item) {
      this.$refs.delete.open(item.id);
    },
    async onClickExport() {
      try {
        const token = JwtService.getToken();
        if (!token) return;

        const params = {};

        if (this.memberRoleId) {
          params.active_role = this.memberRoleId;
        }
        if (this.filterFitnessConsultant) {
          params.fitness_consultant_id = this.filterFitnessConsultant;
        }
        if (this.filterPersonalTrainer) {
          params.personal_trainer_id = this.filterPersonalTrainer;
        }

        // Filter: member yang sudah expired (membership_expired_date <= hari ini)
        if (this.filterExpiredOnly) {
          params.expired_date_end = Moment().format("YYYY-MM-DD");
        } else {
          if (this.filterExpiredDateStart) {
            params.expired_date_start = Moment(this.filterExpiredDateStart, "DD/MM/YYYY").format("YYYY-MM-DD");
          }
          if (this.filterExpiredDateEnd) {
            params.expired_date_end = Moment(this.filterExpiredDateEnd, "DD/MM/YYYY").format("YYYY-MM-DD");
          }
        }

        const queryString = new URLSearchParams({
          token,
          ...params,
        }).toString();

        const url = `${process.env.VUE_APP_SERVER_URL}/user/export?${queryString}`;
        window.open(url, "_blank");
      } catch (e) {
        this.$swal.fire({
          icon: "error",
          title: "Gagal",
          text: "Gagal mengunduh data member. " + (e.message || ""),
          showConfirmButton: true,
        });
      }
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    },
  },

  components: {
    Datatable,
    DeleteDialog,
    FormUser,
  },
  computed: {
    canAdd() {
      if (!this.$store.getters.hasPermission("member", "create")) {
        return false;
      }

      return true;
    },
  },
  watch: {
    filterFitnessConsultant() {
      this.setDefaultFilter();
    },
    filterPersonalTrainer() {
      this.setDefaultFilter();
    },
    filterExpiredOnly() {
      this.setDefaultFilter();
    },
    filterExpiredDateStart() {
      this.setDefaultFilter();
    },
    filterExpiredDateEnd() {
      this.setDefaultFilter();
    },
  },
};
</script>
